"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generationMethods = void 0;
// Array of generation methods.
exports.generationMethods = [
    'string',
    'bytes',
    'base32',
    'base62',
    'uuidv4',
    'uuidv5',
];
//# sourceMappingURL=types.js.map